export default __webpack_public_path__ + "static/media/studio-cartoon-figure.7bf8e7b2.png";